"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.527 18c1.393 0 2.526 1.122 2.526 2.503 0 1.379-1.133 2.503-2.526 2.503-1.394 0-2.527-1.124-2.527-2.503C15 19.122 16.133 18 17.527 18Zm0 1.539a.969.969 0 0 0-.974.964.97.97 0 0 0 .974.965.97.97 0 0 0 .974-.965.97.97 0 0 0-.974-.964Zm-9 1.929a.97.97 0 0 1-.974-.965c0-.533.436-.964.974-.964a.97.97 0 0 1 .974.964.97.97 0 0 1-.974.965Zm0-3.468c1.394 0 2.527 1.122 2.527 2.503 0 1.379-1.133 2.503-2.527 2.503C7.133 23.006 6 21.882 6 20.503 6 19.122 7.133 18 8.527 18ZM2.028 2h2.625c.446 0 .838.29.975.702l.031.116.333 1.726h10.141l.06.166c.156.438.392.84.72 1.224l.171.19.4.422H6.409l1.167 5.761 12.801-1.536.474-3.283.172-.036c.48-.099.938-.285 1.367-.558l.213-.143.477-.341-.688 4.765a1.899 1.899 0 0 1-1.494 1.579l-.157.026-12.634 1.518c.266.392.689.65 1.163.697l.16.008h10.976c.566 0 1.027.457 1.027 1.019 0 .526-.402.959-.915 1.014l-.112.006H9.43a3.657 3.657 0 0 1-3.537-2.723l-.043-.185L3.812 4.037H2.028A1.024 1.024 0 0 1 1 3.019c0-.525.402-.958.916-1.013L2.028 2h2.625-2.625Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
    cx: 20,
    cy: 3,
    r: 3
  })]
});